<!-- 会员类型搜索dialog -->
<template>
  <div class="vipHeaderDialog">
    <el-button type="info" icon="el-icon-search" @click="dialog = true">客户搜索</el-button>

    <el-dialog
      :title="dialogMode === 'compare' ? '对比客户搜索' : '客户搜索'"
      :visible.sync="dialog"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      @close="changeCancel"
    >
      <div class="vipHeaderDialog_content">
        <div style="margin-bottom: 10px;">选择时间范围和客户类型条件进行搜索筛选</div>
        <el-card>
            <div slot="header">客户身份时间选择</div>
            <div>
              <div v-if="userDateTypeArr.length > 0">
                <div class="header-title">时间颗粒度</div>
                <el-radio-group class="userDateTypeRadio" v-model="paramsDate.dateType">
                    <el-radio v-for="(item,index) in userDateTypeArr" :key="index" :label="item.dictValue">{{ item.dictLabel }}</el-radio>
                </el-radio-group>
              </div>
              <!-- <div class="headder-customTime" v-else>
                <div style="margin-right: 20px;">
                  <div>开始时间</div>
                  <el-date-picker
                    v-model="paramsDate.startTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="开始时间"
                    >
                  </el-date-picker>
                </div>
                <div>
                  <div>结束时间</div>
                  <el-date-picker
                    v-model="paramsDate.endTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="结束时间"
                    >
                  </el-date-picker>
                </div>
              </div> -->
              <div class="curstomUserDateRangeDiv" v-if="showDateTypeRange">
                <div class="curstomUserDateRangeDiv-item">
                  <div class="curstomUserDateRangeDiv-item-title">开始时间</div>
                  <div>
                    <el-date-picker
                      size="large"
                      :clearable="false"
                      v-model="paramsDate.startTime"
                      type="date"
                      placeholder="开始时间"
                      value-format="yyyy-MM-dd"
                    ></el-date-picker>
                  </div>
                </div>
                <div class="curstomUserDateRangeDiv-item">
                  <div class="curstomUserDateRangeDiv-item-title">结束时间</div>
                  <div>
                    <el-date-picker
                      size="large"
                      :clearable="false"
                      v-model="paramsDate.endTime"
                      type="date"
                      placeholder="结束时间"
                      value-format="yyyy-MM-dd"
                    ></el-date-picker>
                  </div>
                </div>
                <!-- <el-date-picker
                  style="width: 50%;"
                  v-model="curstomUserDateRange"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  align="right"
                  unlink-panels
                  :picker-options="pickerOptions"
                  :default-value="defaultMonth"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  >
                </el-date-picker> -->
              </div>

            </div>

        </el-card>
        <el-card>
            <div slot="header">客户类型选择</div>
            <div>
              <div class="userTypeDiv">
                <div class="userTypeDiv-item">
                  <div class="userTypeDiv-item-title">
                    <span>生命周期</span>
                    <el-tooltip popper-class="userTypeDiv-item-title-tooltip" effect="dark" placement="top">
                      <div slot="content" style="font-size: 10px !important;max-width: 200px;">
                        <div class="tooltips-content-overWidth">
                            <span>体验客：</span>
                            <span class="tooltips-content-overWidth_content">在身份统计时间段内，新客中通过拓客券在门店进行消费产生的订单，将用户身份标识为体验客</span>
                        </div>
                        <div>新客：首次购买的客户</div>
                        <div>老客：重复购买的客户</div>
                        <div>散客：偶尔购买的客户</div>
                        </div>
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  </div>
                  <div class="userTypeDiv-item-content">
                    <check-all-group
                      v-model="paramsDate.memberTypeList"
                      :options="userMemberTypeArr"
                      value-key="dictValue"
                      label-key="dictLabel"
                      all-label="全部"
                    />
                    <!-- <el-checkbox-group v-model="paramsDate.memberTypeList"  @change="onMemberTypeChange">
                      <el-checkbox v-for="(item,index) in userMemberTypeArr" :key="index" :label="item.dictValue">{{ item.dictLabel }}</el-checkbox>
                    </el-checkbox-group> -->
                  </div>
                </div>
                <div class="userTypeDiv-item">
                  <div class="userTypeDiv-item-title">
                    <span>会员属性</span>
                    <el-tooltip popper-class="userTypeDiv-item-title-tooltip" effect="dark" placement="top">
                      <div slot="content">根据消费金额和频次划分的会员等级<br/>普卡：基础会员<br/>紫卡：银级会员<br/>银卡：金级会员<br/>金卡：钻石会员</div>
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  </div>
                  <div class="userTypeDiv-item-content">
                    <check-all-group
                      :identifyKey="identifyKey"
                      v-model="paramsDate.memberLevelList"
                      :options="userMemberLevelArr"
                      value-key="dictValue"
                      label-key="dictLabel"
                      all-label="全部"
                    />
                    <!-- <el-checkbox-group v-model="paramsDate.memberLevelList">
                      <el-checkbox v-for="(item,index) in userMemberLevelArr" :key="index" :label="item.dictValue">{{ item.dictLabel }}</el-checkbox>
                    </el-checkbox-group> -->
                  </div>
                </div>
                <div class="userTypeDiv-item">
                  <div class="userTypeDiv-item-title">
                    <span>权益卡</span>
                    <el-tooltip popper-class="userTypeDiv-item-title-tooltip" effect="dark" placement="top">
                      <div slot="content">权益卡：享受特殊优惠和服务的卡片<br/>持卡：拥有权益卡的客户<br/>未持卡：没有权益卡的客户</div>
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  </div>
                  <div class="userTypeDiv-item-content">
                    <check-all-group
                      v-model="paramsDate.cardList"
                      :options="userHaveCardArr"
                      value-key="dictValue"
                      label-key="dictLabel"
                      all-label="全部"
                    />
                    <!-- <el-checkbox-group v-model="paramsDate.cardList">
                      <el-checkbox v-for="(item, index) in userHaveCardArr" :key="index" :label="item.dictValue">{{ item.dictLabel }}</el-checkbox>
                    </el-checkbox-group> -->
                  </div>
                </div>
                <div class="userTypeDiv-item">
                  <div class="userTypeDiv-item-title">
                    <span>预付卡</span>
                    <el-tooltip popper-class="userTypeDiv-item-title-tooltip" effect="dark" placement="top">
                      <div slot="content">储值卡：预存金额的卡片<br/>次卡：预存次数的卡片<br/>根据余额状态进行筛选</div>
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  </div>
                  <div class="userTypeDiv-item-content">
                    <check-all-group
                      v-model="paramsDate.prepayCardList"
                      :options="userPrepaidCardArr"
                      value-key="dictValue"
                      label-key="dictLabel"
                      all-label="全部"
                    />
                    <!-- <el-checkbox-group v-model="paramsDate.prepayCardList">
                      <el-checkbox v-for="(item,index) in userPrepaidCardArr" :key="index" :label="item.dictValue">{{ item.dictLabel }}</el-checkbox>
                    </el-checkbox-group> -->
                  </div>
                </div>
                <div class="userTypeDiv-item">
                  <div class="userTypeDiv-item-title">
                    <span>来源渠道</span>
                    <el-tooltip popper-class="userTypeDiv-item-title-tooltip" effect="dark" placement="top">
                      <div slot="content">客户首次了解或接触品牌的渠道来源<br/>包括线上平台、线下推广等多种渠道</div>
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  </div>
                  <div class="userTypeDiv-item-content">
                    <check-all-group
                      v-model="paramsDate.channelList"
                      :options="channelListArr || []"
                      value-key="value"
                      label-key="label"
                      all-label="全部"
                    />
                    <!-- <el-checkbox-group v-model="paramsDate.channelList">
                      <el-checkbox v-for="(item,index) in channelListArr" :key="index" :label="item.label" :value="item.value"></el-checkbox>
                    </el-checkbox-group> -->
                  </div>
                </div>
              </div>
              <div class="userType-store">
                <div class="userType-store-title">
                  <span>归属门店</span>
                  <el-tooltip popper-class="userTypeDiv-item-title-tooltip" effect="dark" placement="top">
                      <div slot="content">按品牌、分公司、区域、门店四级结构选择<br/>支持门店名称搜索快速定位</div>
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                </div>
                <tree-store :resetFlag="resetFlag" :checkedStoreIdList.sync="checkedStoreIdList" :allStoreInfoList.sync="allStoreInfoList" :treeStoreData="treeStoreData" />
              </div>
            </div>
        </el-card>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="handleReset">重置</el-button>
        <el-button type="primary" size="medium"  @click="handleSave">搜索</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CheckAllGroup from '../select/select_checkAllGroup.vue'
import TreeStore from "../select/select_treeStore.vue"
import axios from '../../../common/http'
import { extractStoreType2 } from '../../../common/util'
export default {
  name: 'vipHeaderDialog',
  props:{
    identifyKey: {
      type: String,
      default: ""
    },
    propByWhichWay: {
      type: String,
      default: ""
    },
    propDateRange: {
      type: Array,
      default: function() {
        return [];
      }
    },
    headerMemberInfoQueryParam: {
      type: Object,
      default: () => ({}),
    },
    userSearchOptionsAll: {
      type: Object,
      default: () => ({}),
    },
    userDateTypeArr:{
      type: Array,
      default: () => []
    },
    showDateTypeRange: {  //是否显示日期范围
      type: Boolean,
      default: false
    },
    dialogMode: {
      type: String,
      default: 'main',
      validator: (value) => ['main', 'compare'].includes(value)
    }
  },
  components: {
    CheckAllGroup,
    TreeStore
  },
  data() {
    return {
      dialog: false,
      pickerOptions: {
        disabledDate: (time) => {
          // 禁用未来的日期（大于今天的时间戳）
          return time.getTime() > Date.now();
        }
      },
      defaultMonth: [
        new Date(new Date().setMonth(new Date().getMonth() - 1)), // 上个月
        new Date() // 本月
      ], // 面板默认显示当前月份
      userMemberTypeArrClone: [],
      userMemberTypeArr: [],
      userMemberLevelArr: [],
      userHaveCardArr: [],
      userPrepaidCardArr: [],
      // userDateTypeArr: this.headerTimeLineList || [],
      curstomUserDateRange: [], //时间范围选择项 自定义时间区间
      paramsDate: {
        byWhichWay: '',
        startTime: '',
        endTime: '',
        storeIds: [],
        memberTypeList: [],
        memberLevelList: [],
        cardList: [],
        prepayCardList: [],
        dateType: null,
        channelList: [],
      },
      checkedStoreIdList: [], //门店ID列表
      resetFlag: false,
      allStoreInfoList: [], //所有可选门店信息
      treeStoreData: [], //门店树数据（从接口获取）
      bulkChannelListData: [], //来源渠道数据（从接口获取）
      hasInitialized: false, //标志位：是否已完成初始化
    }
  },
  computed: {
    channelListArr() {
      if (!this.bulkChannelListData || this.bulkChannelListData.length === 0) {
        return []
      }
      // 排除第一个"全部"选项
      const arr = this.bulkChannelListData.slice(1)
      return arr || []
    }
  },
  watch: {
    propByWhichWay:{
      async handler(val) {
        // 如果弹窗已打开，不执行同步逻辑，让用户在弹窗内自由选择
        if (this.dialog) {
          return
        }

        if(val) {
          const matchedItem = this.userDateTypeArr.filter(item => item.byWhichWay === val)[0]
          if (matchedItem) {
            const newDateType = matchedItem.dictValue
            // 只有当 dateType 真正发生变化时才更新
            if (this.paramsDate.dateType !== newDateType) {
              // this.paramsDate.dateType = newDateType
            }
          }
        }
      },
      immediate: true
    },
    showDateTypeRange:{
      handler(val) {
        if (val) {
          const paramsDataObj = JSON.parse(JSON.stringify(this.paramsDate))
          paramsDataObj.startTime = this.propDateRange[0] || ''
          paramsDataObj.endTime = this.propDateRange[1] || ''
        } else {
          // this.dateType = null
        }
      },
      immediate: true
    },
    checkedStoreIdList(arr) {
      this.paramsDate.storeIds = arr
    },
    headerMemberInfoQueryParam: {
      deep: true,
      handler(val) {
        if (val && Object.keys(val).length) {
          // 同步给本地 paramsDate（浅对比避免不必要的更新）
          const hasChanged = Object.keys(val).some(key => {
            return JSON.stringify(this.paramsDate[key]) !== JSON.stringify(val[key])
          })
          if (hasChanged) {
            this.paramsDate = { ...this.paramsDate, ...val }
            this.checkedStoreIdList = val.storeIds || []
          }
        }
      },
      immediate: true
    },
    userSearchOptionsAll: {
      deep: true,
      handler(val) {
        if (val && Object.keys(val).length) {
          const {
            userMemberTypeArr,
            userMemberLevelArr,
            userHaveCardArr,
            userPrepaidCardArr,
            // userDateTypeArr,
            userChannelListArr,
            allStoreInfoArr,
          } = val

          this.userMemberTypeArr = userMemberTypeArr || this.userMemberTypeArr
          this.userMemberLevelArr = userMemberLevelArr || this.userMemberLevelArr
          this.userHaveCardArr = userHaveCardArr || this.userHaveCardArr
          this.userPrepaidCardArr = userPrepaidCardArr || this.userPrepaidCardArr
        //   this.userDateTypeArr = userDateTypeArr || this.userDateTypeArr
          this.userChannelListArr = userChannelListArr || this.userChannelListArr
          this.allStoreInfoList = allStoreInfoArr || this.allStoreInfoList
        }
      }
    },
    dialog: {
      handler(val) {
        if (val && this.propByWhichWay) {
          const matchedItem = this.userDateTypeArr.filter(item => item.byWhichWay === this.propByWhichWay)[0]
          if (matchedItem) {
            const newDateType = matchedItem.dictValue
            if (this.paramsDate.dateType !== newDateType) {
              // this.paramsDate.dateType = newDateType
            }
          }
        }
      }
    },
    // 监听 identifyKey 变化，当切换到 market_member_level_general 时自动更新 memberLevelList
    identifyKey: {
      handler(val) {
        // 当切换到 market_member_level_general 时，确保 memberLevelList 为全选
        if (val === 'market_member_level_general' && this.userMemberLevelArr.length > 0) {
          const allLevelIds = this.userMemberLevelArr.map(item => item.dictValue)
          // 避免重复赋值
          if (JSON.stringify(this.paramsDate.memberLevelList) !== JSON.stringify(allLevelIds)) {
            this.paramsDate.memberLevelList = allLevelIds
            // 立即同步到父组件
            this.$emit('update:headerMemberInfoQueryParam', {...this.paramsDate})
            this.updateDialogOptions()
          }
        }
        if (val === 'cust_source_ana_member_source_worth') {
          this.paramsDate.dateType = '3'
          this.$emit('update:headerMemberInfoQueryParam', {...this.paramsDate})
          this.updateDialogOptions()
        }
      },
      immediate: false
    },
    // 监听 allStoreInfoList 的变化，作为初始化的兜底机制
    allStoreInfoList: {
      handler(val) {
        // 仅在首次数据加载且未初始化时执行（兜底机制）
        if (val.length > 0 && !this.hasInitialized) {
          this.hasInitialized = true
          this.handleReset()
          this.$emit('update:headerMemberInfoQueryParam', {...this.paramsDate})
          this.updateDialogOptions()
        }
      },
      deep: false,
      immediate: false
    }
  },
  async mounted() {
    // 先尝试从 sessionStorage 读取，如果没有或为空则请求接口
    let memberTypeArr = await this.getOrFetchParams("user_member_type")

    //会员分析模块 "散客" 禁用不可选
    if((this.identifyKey.indexOf('market_') > -1 || this.identifyKey === 'retained_analysis_member_retain' || this.identifyKey === 'retained_analysis_member_retain_consume' || this.identifyKey === 'loyalty_member_purchase_cycle_table_key' || this.identifyKey === "loyalty_member_consume_frequency_table_key" || this.identifyKey === 'cust_source_ana_member_source_trend' || this.identifyKey === "cust_source_ana_member_source_worth") && memberTypeArr.length > 0){
      // 给最后一个选项（散客）添加 disabled 属性
      this.userMemberTypeArr = memberTypeArr.map((item, index) => ({
        ...item,
        disabled: index === memberTypeArr.length - 1
      }))
    } else {
      this.userMemberTypeArr = memberTypeArr
    }

    // 加载其他参数（优先从缓存读取，没有则请求接口）
    this.userMemberLevelArr = await this.getOrFetchParams("user_member_level")
    this.userHaveCardArr = await this.getOrFetchParams("user_have_card")
    this.userPrepaidCardArr = await this.getOrFetchParams("user_prepaid_card")

    // 加载门店树数据
    this.treeStoreData = await this.getTreeStoreData()

    // 加载来源渠道数据
    this.bulkChannelListData = await this.getBulkChannelList()

    // 初始化时同步选项数据到父组件
    this.updateDialogOptions()

    // 等待 Vue 完成 DOM 更新，让子组件有机会执行 computed 和 emit
    await this.$nextTick()
    await this.$nextTick()

    // 如果数据已就绪，立即初始化（优先使用 allStoreInfoList，否则用 treeStoreData 兜底）
    if (!this.hasInitialized && (this.allStoreInfoList.length > 0 || (this.treeStoreData && this.treeStoreData.length > 0))) {
      this.hasInitialized = true
      this.handleReset()
      this.$emit('update:headerMemberInfoQueryParam', {...this.paramsDate})
      this.updateDialogOptions()
    }
    // 如果数据未就绪（异步场景），由 allStoreInfoList watcher 兜底处理
  },
  methods: {
    // 优先从 sessionStorage 读取，没有或为空则请求接口
    async getOrFetchParams(key) {
      const cacheKey = `vip_header_params_${key}`

      // 1. 先尝试从 sessionStorage 读取
      try {
        const cachedData = sessionStorage.getItem(cacheKey)
        if (cachedData) {
          const parsedData = JSON.parse(cachedData)
          if (parsedData && Array.isArray(parsedData) && parsedData.length > 0) {
            return parsedData
          }
        }
      } catch (e) {
        // 缓存读取失败，继续请求
      }

      // 2. 如果缓存没有或为空，请求接口
      return await this.getQueryParamsDictDate(key)
    },

    // 获取门店树数据（优先缓存 -> 接口 -> localStorage兜底）
    async getTreeStoreData() {
      const cacheKey = 'vip_header_params_treeStore'

      // 1. 优先从 sessionStorage 读取
      try {
        const cachedData = sessionStorage.getItem(cacheKey)
        if (cachedData) {
          const parsedData = JSON.parse(cachedData)
          if (parsedData && Array.isArray(parsedData) && parsedData.length > 0) {
            return parsedData
          }
        }
      } catch (e) {
        // 缓存读取失败，继续请求
      }

      // 2. 请求接口
      try {
        const res = await axios.post('/loginLogoutController/user/right/allStores', { orgId: 1, storeType: 0 })
        const { data } = res
        if (data.errorCode == 0 && data.data) {
          // 接口返回的是单个对象，需要包装成数组（与 localStorage 格式一致）
          const result = [data.data]
          // 缓存到 sessionStorage
          try {
            sessionStorage.setItem(cacheKey, JSON.stringify(result))
          } catch (e) {
            // 忽略缓存错误
          }
          return result
        }
      } catch (e) {
        // 接口请求失败
      }

      // 3. 兜底：从 localStorage 读取
      try {
        const localData = JSON.parse(localStorage.getItem('treeStore'))
        if (localData && Array.isArray(localData) && localData.length > 0) {
          return localData
        }
      } catch (e) {
        // localStorage 读取失败
      }

      return []
    },

    // 获取来源渠道数据（优先缓存 -> 接口 -> localStorage兜底）
    async getBulkChannelList() {
      const cacheKey = 'vip_header_params_bulkChannelList'

      // 1. 优先从 sessionStorage 读取
      try {
        const cachedData = sessionStorage.getItem(cacheKey)
        if (cachedData) {
          const parsedData = JSON.parse(cachedData)
          if (parsedData && Array.isArray(parsedData) && parsedData.length > 0) {
            return parsedData
          }
        }
      } catch (e) {
        // 缓存读取失败，继续请求
      }

      // 2. 请求接口
      try {
        const res = await axios.post('controller/common/getAllBulkChannelList', {})
        const { data } = res
        if (data.errorCode == 0 && data.data && data.data.length > 0) {
          let result = data.data.map(item => ({
            value: item.id,
            label: item.name
          }))
          result.unshift({ value: -1, label: '全部' })

          // 缓存到 sessionStorage
          try {
            sessionStorage.setItem(cacheKey, JSON.stringify(result))
          } catch (e) {
            // 忽略缓存错误
          }
          return result
        }
      } catch (e) {
        // 接口请求失败
      }

      // 3. 兜底：从 localStorage 读取
      try {
        const localData = JSON.parse(localStorage.getItem('bulkChannelList'))
        if (localData && Array.isArray(localData) && localData.length > 0) {
          return localData
        }
      } catch (e) {
        // localStorage 读取失败
      }

      return []
    },

    updateDialogOptions() {
      const userSearchOptionsAll = {
        userMemberLevelArr: this.userMemberLevelArr,
        userMemberTypeArr: this.userMemberTypeArr,
        userHaveCardArr: this.userHaveCardArr,
        userPrepaidCardArr: this.userPrepaidCardArr,
        userDateTypeArr: this.userDateTypeArr,
        userChannelListArr: this.channelListArr,
        allStoreInfoArr: this.allStoreInfoList
      }
      // 针对生命周期
      if (this.userMemberTypeArr.length === 3) {
        userSearchOptionsAll.userMemberTypeArr = []
      }
      this.$emit('update:userSearchOptionsAll',{...userSearchOptionsAll})
    },

    async getQueryParamsDictDate(key, retryCount = 0) {
      const maxRetries = 3; // 最大重试次数
      const retryDelay = 1000; // 重试延迟（毫秒）
      const cacheKey = `vip_header_params_${key}`; // sessionStorage 缓存键名

      try {
        let res = await axios.get("dict/listData?dictKey=" + key)
        const {data} = res
        if(data.errorCode == 0 && data.data && data.data.length > 0) {
          let dataArr = data.data.map(item => ({
            ...item,
            dictValue: parseInt(item.dictValue, 10)
          }))

          // 请求成功，缓存数据到 sessionStorage
          try {
            sessionStorage.setItem(cacheKey, JSON.stringify(dataArr))
          } catch (e) {
            // 忽略缓存错误
          }

          return dataArr
        } else {
          // 数据为空或错误码不为0，尝试重试
          throw new Error('Data is empty or error code is not 0')
        }
      } catch (error) {
        // 如果还有重试次数，进行重试
        if (retryCount < maxRetries) {
          await new Promise(resolve => setTimeout(resolve, retryDelay * (retryCount + 1)))
          return this.getQueryParamsDictDate(key, retryCount + 1)
        }

        // 所有重试都失败，返回空数组
        return []
      }
    },

    onMemberTypeChange() {
      // 会员类型变化处理（预留）
    },

    changeCancel() {
      // 关闭对话框，不清空任何数据
      this.dialog = false
    },

    handleSave() {
      const _this = this
      let params = JSON.parse(JSON.stringify(_this.paramsDate))
      // 确保使用用户选择的门店ID，而不是默认的全部门店
      params.storeIds = _this.checkedStoreIdList

      _this.paramsDate = params
      this.$emit('update:headerMemberInfoQueryParam',{...this.paramsDate})
      this.updateDialogOptions()
      _this.dialog = false
    },

    async handleReset() {
      this.resetFlag = !this.resetFlag;

      // 从接口获取的门店树数据作为备选方案
      let allStores = this.allStoreInfoList || []

      // 如果 allStoreInfoList 为空，尝试从 treeStoreData 提取
      if (allStores.length === 0 && this.treeStoreData && this.treeStoreData[0] && this.treeStoreData[0].subList && this.treeStoreData[0].subList[0]) {
        allStores = extractStoreType2(this.treeStoreData[0].subList[0])
      }

      // 如果仍然为空，记录警告（帮助调试）
      if (allStores.length === 0) {
        console.warn('[vip_header_dialog] handleReset: 门店数据为空，请检查数据加载是否完成')
      }
      if (this.userMemberLevelArr.length === 0) {
        this.userMemberLevelArr = await this.getOrFetchParams("user_member_level")
      }
      if(this.userHaveCardArr.length === 0) {
        this.userHaveCardArr = await this.getOrFetchParams("user_have_card")
      }
      if(this.userPrepaidCardArr.length === 0) {
        this.userPrepaidCardArr = await this.getOrFetchParams("user_prepaid_card")
      }
      if(this.bulkChannelListData.length === 0) {
        this.bulkChannelListData = await this.getBulkChannelList()
      }

      const allStoreIds = allStores.map(item => item.id)

      // 根据 propByWhichWay 确定正确的 dateType，而不是总是使用第一个
      let initialDateType = this.userDateTypeArr[0].dictValue
      if (this.propByWhichWay) {
        const matchedItem = this.userDateTypeArr.find(item => item.byWhichWay === this.propByWhichWay)
        if (matchedItem) {
          initialDateType = matchedItem.dictValue
        }
      }

      this.paramsDate = {
        startTime: this.propDateRange[0] || '',
        endTime: this.propDateRange[1] || '',
        storeIds: allStoreIds, // 默认选择全部门店
        memberTypeList: this.userMemberTypeArr.filter(item => !item.disabled).map(item => item.dictValue),
        memberLevelList: this.userMemberLevelArr.map(item => item.dictValue),
        cardList: this.userHaveCardArr.map(item => item.dictValue),
        prepayCardList: this.userPrepaidCardArr.map(item => item.dictValue),
        dateType: initialDateType,
        channelList: this.channelListArr.map(item => item.value),
      }

      // 同步更新 checkedStoreIdList，确保 TreeStore 组件显示正确的选中状态
      this.checkedStoreIdList = allStoreIds
      this.curstomUserDateRange = []
    },

    openDialog() {
      this.dialog = true
    }
  },
}
</script>
<!-- <style lang="less">
.userTypeDiv-item-title-tooltip {
    max-width:  auto !important;
  }
</style> -->

<style lang="less" scoped>

  .vipHeaderDialog {
    ::v-deep .el-dialog__body {
      height: 65vh !important;
      overflow-y: auto !important;
    }
    .vipHeaderDialog_content{
      padding: 10px 20px 0 20px;
      .el-card {
        margin-bottom: 10px;
      }
      .header-title {
        margin-top: -10px;
        margin-bottom: 5px;
      }
    }
    .userDateTypeRadio {
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;
      align-items: center;
      label {
        width: 20%;
        margin-right: 0;
        margin-bottom: 10px;
      }
    }
    .headder-customTime {
      display: flex;
      align-items: flex-start;
    }
    .curstomUserDateRangeDiv {
      display: flex;
      .curstomUserDateRangeDiv-item {
        width: 50%;
        .curstomUserDateRangeDiv-item-title {
          margin-bottom: 10px;
        }
      }
      // justify-content: flex-end;
      // .el-input__inner {
      //   width: 240px;
      // }
    }
    .tooltips-content-overWidth{
        display: flex !important;
        // align-items: flex-start;
        justify-content: flex-start !important;
        .tooltips-content-overWidth_content{
            flex: 1 !important;
        }
    }
    .userTypeDiv {
      display: flex;
      // justify-content: space-between;
      align-items: flex-start;
      flex-wrap: wrap;
      .userTypeDiv-item {
        width: 33.33%;
        // margin-bottom: 10px;
        .userTypeDiv-item-title-tooltip {
          max-width:  auto !important;
        }
        .userTypeDiv-item-title {
          display: flex;
          align-items: center;
          margin-bottom: 10px;

          i{
            margin-left: 4px;
          }
        }
        .userTypeDiv-item-content {
          height: 140px;
          overflow-y: auto;
          div {
            display: flex;
            flex-direction: column;
            label {

            }
          }
        }
      }
    }
    .userType-store {
      .userType-store-title {
        margin: 20px 0;
      }
    }
    .dialog-footer{
      padding: 10px 20px 20px;
    }
  }
</style>
